import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadAllMilestones } from './../../../../ng2/store/actions/milestone-actions';
import {
  getAllMilestoneLoadedStatus,
  getMilestoneEntitiesList,
} from './../../../../ng2/store/selectors/milestone-selectors';

@Injectable()
export class MilestonesResolver {
  resolveMilestones$(currentSchool, store): Promise<Observable<any>> {
    const { _id } = currentSchool;
    const payload = { schoolId: _id };
    const destroy$: Subject<boolean> = new Subject<boolean>();
    return new Promise(resolve => {
      store
        .select(getAllMilestoneLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe(allLoaded => {
          if (!allLoaded) store.dispatch(new LoadAllMilestones(payload));
          if (allLoaded) {
            const milestonesEntities$ = store.select(getMilestoneEntitiesList);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(milestonesEntities$);
          }
        });
    });
  }
}
